import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PeriodsService } from 'src/app/service/periods.service';
import { BoardsService } from 'src/app/service/boards.service';
import { Location } from '@angular/common';
import { FormControl } from '@angular/forms';
import { ReplaySubject, map, startWith } from 'rxjs';


@Component({
  selector: 'app-edit-period',
  templateUrl: './edit-period.component.html',
  styleUrls: ['./edit-period.component.scss'],
  standalone: false,  // NOSONAR
})
export class EditPeriodComponent implements OnInit {
  selectedRegions: { label: string; value: string }[] = [];

  userdropdownTemp: any = [];
  userdropdown: any = [];
  temp2: string;
  userData;
  selected_puser;
  selected_suser;
  selected_region;
  selected_period;
  selected_board;
  selected_dday = 0;

  temp4;
  temp5;

  temp: string;
  temp3: string;
  regionList: any;
  selectedRegionsTemp: any = [];
  taskData;
  selectedTask;

  options;
  selected_duetime;

  periodData;
  boardData;


  successMessage = '';
  errorMessage = '';

  selected_region_Temp_final: any = [];
  userID;
  usertemp: string;
  userInfo: any;

  selected_sequence = 0;
  boardDescription;
  taskDescription;

  boardID;
  tempData;
  taskID;

  selectedRegionTemp = [];

  boardTaskID;

  puserName;
  suserName;
  s_region_flag: boolean = true;
  selected_reg;
  selected_pValue: any;
  selected_sValue: any;
  regionFilterCtrl: FormControl = new FormControl();
  filteredRegions: ReplaySubject<{ label: string; value: string }[]> = new ReplaySubject(1);
  userFilterCtrl: FormControl = new FormControl('');
  puserFilterCtrl: FormControl = new FormControl('');
  filteredUsers: ReplaySubject<{ label: string; value: string }[]> = new ReplaySubject(1);
  filteredUserDropdown: any;
  filteredUserDpdown: any;
  searchText: string = '';
  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly boardService: BoardsService,
    private readonly location: Location) {

    // reading from location state
    const data: any = this.location.getState();
    console.info("the data", data.params);


    this.taskDescription = data.params.TASK;
    this.selected_sequence = data.params.SEQUENCE;
    this.selected_duetime = data.params.DUE.substring(11, 16);

    if (data.params.DDAY[1] == '-') { // NOSONAR
      this.selected_dday = data.params.DDAY.substring(1);
    } else {
      this.selected_dday = data.params.DDAY.substring(2);
    }
    
    if (data.params.PERIOD_NAME && data.params.PERIOD_NAME != 'null') { // NOSONAR
      const periodArr = data.params.PERIOD_NAME.split('|');
      this.selected_period = periodArr.length > 2 ? periodArr[2] : null;
    } else {
      this.selected_period = null;
    }

    let tempUserArr = [];

    let regionsArr = [];
    let keyTemp;

    this.selected_region = [];
    this.selectedRegionTemp = [];

    // populate regions
    Object.keys(data.params).forEach(function (key) {

      if (key == "USER") { // NOSONAR
        tempUserArr = data.params[key].split("|");
      }

      

      if (data.params[key] != "null" && key != "USER") { // NOSONAR
        regionsArr.push({ "label": data.params[key].split("|")[10], "value": key });
      }

      regionsArr = regionsArr.filter(
        item => item.label != undefined && item.value != undefined // NOSONAR
      );


    });

    console.info("regions array", regionsArr);



    regionsArr?.forEach(element => {


      const obj = { "label": element.label, "value": element.value };
      this.selectedRegionTemp.push(obj);
    });

    this.selected_region = this.selectedRegionTemp;
    console.info("selected region", this.selected_region);


    this.boardTaskID = data.params.BOARD_TASK_ID;



    this.ngxUiLoaderService.start("loader-01");


    //fetch from local-storage
    this.temp = localStorage.getItem('task-data');
    this.taskData = JSON.parse(this.temp);

    //fetch from local-storage
    this.temp3 = localStorage.getItem('region-data');
    this.regionList = JSON.parse(this.temp3);

    this.regionList?.forEach(element => {


      const obj = { "label": element.region, "value": element.region_code };
      this.selectedRegionsTemp.push(obj);
    });

    this.selectedRegions = this.selectedRegionsTemp;
    console.info("selected regions", this.selectedRegions);


    //fetch from local-storage
    this.temp2 = localStorage.getItem('users-data');
    this.userData = JSON.parse(this.temp2);

    console.info("tempUserArr", tempUserArr);


    this.userData?.forEach(element => {



      const obj = { "label": element.firstName + ' ' + element.lastName, "value": element.userPrincipalName };
      this.userdropdownTemp.push(obj);

      if (element.userPrincipalName == tempUserArr[8]) { // NOSONAR
        this.puserName = element.firstName + ' ' + element.lastName;
      }

      if (element.userPrincipalName == tempUserArr[9]) { // NOSONAR
        this.suserName = element.firstName + ' ' + element.lastName;
      }

    });

    this.userdropdown = this.userdropdownTemp;
    this.filteredUserDropdown = [...this.userdropdown];
    this.filteredUserDpdown = [...this.userdropdown];




    // selected user

    this.selected_puser = { "value": tempUserArr[8], "label": this.puserName };
    this.selected_suser = { "value": tempUserArr[9], "label": this.suserName };

    console.info(this.selected_puser, "this.selected_puser")
    console.info(this.selected_suser, "this.selected_suser")



    //fetch from local-storage
    this.temp4 = localStorage.getItem('period-data');
    this.periodData = JSON.parse(this.temp4);

    this.temp5 = localStorage.getItem('board-data');
    this.boardData = JSON.parse(this.temp5);

    this.boardService.getboardtaskslist().subscribe(result => {


      if (result?.length > 0) {

        this.tempData = result;
        this.tempData.filter(x => x.boardTaskID == this.boardTaskID).forEach(e => { // NOSONAR

          this.boardID = e.boardID;
          this.taskID = e.taskID;
        });

        this.boardData.filter(x => x.boardID == this.boardID).forEach(element => { // NOSONAR
          this.boardDescription = element.description;

        });


      }

      else {
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);

      }


      this.ngxUiLoaderService.stop("loader-01");

    });





    this.options = ["00:00", "00:05", "00:10", "00:15", "00:20", "00:25", "00:30",
      "00:35", "00:40", "00:45", "00:50", "00:55", "01:00", "01:05", "01:10",
      "01:15", "01:20", "01:25", "01:30", "01:35", "01:40", "01:45", "01:50",
      "01:55", "02:00", "02:05", "02:10", "02:15", "02:20", "02:25", "02:30",
      "02:35", "02:40", "02:45", "02:50", "02:55", "03:00", "03:05", "03:10",
      "03:15", "03:20", "03:25", "03:30", "03:35", "03:40", "03:45", "03:50",
      "03:55", "04:00", "04:05", "04:10", "04:15", "04:20", "04:25", "04:30",
      "04:35", "04:40", "04:45", "04:50", "04:55", "05:00", "05:05", "05:10",
      "05:15", "05:20", "05:25", "05:30", "05:35", "05:40", "05:45", "05:50",
      "05:55", "06:00", "06:05", "06:10", "06:15", "06:20", "06:25", "06:30",
      "06:35", "06:40", "06:45", "06:50", "06:55", "07:00", "07:05", "07:10",
      "07:15", "07:20", "07:25", "07:30", "07:35", "07:40", "07:45", "07:50",
      "07:55", "08:00", "08:05", "08:10", "08:15", "08:20", "08:25", "08:30",
      "08:35", "08:40", "08:45", "08:50", "08:55", "09:00", "09:05", "09:10",
      "09:15", "09:20", "09:25", "09:30", "09:35", "09:40", "09:45", "09:50",
      "09:55", "10:00", "10:05", "10:10", "10:15", "10:20", "10:25", "10:30",
      "10:35", "10:40", "10:45", "10:50", "10:55", "11:00", "11:05", "11:10",
      "11:15", "11:20", "11:25", "11:30", "11:35", "11:40", "11:45", "11:50",
      "11:55", "12:00", "12:05", "12:10", "12:15", "12:20", "12:25", "12:30",
      "12:35", "12:40", "12:45", "12:50", "12:55", "13:00", "13:05", "13:10",
      "13:15", "13:20", "13:25", "13:30", "13:35", "13:40", "13:45", "13:50",
      "13:55", "14:00", "14:05", "14:10", "14:15", "14:20", "14:25", "14:30",
      "14:35", "14:40", "14:45", "14:50", "14:55", "15:00", "15:05", "15:10",
      "15:15", "15:20", "15:25", "15:30", "15:35", "15:40", "15:45", "15:50",
      "15:55", "16:00", "16:05", "16:10", "16:15", "16:20", "16:25", "16:30",
      "16:35", "16:40", "16:45", "16:50", "16:55", "17:00", "17:05", "17:10",
      "17:15", "17:20", "17:25", "17:30", "17:35", "17:40", "17:45", "17:50",
      "17:55", "18:00", "18:05", "18:10", "18:15", "18:20", "18:25", "18:30",
      "18:35", "18:40", "18:45", "18:50", "18:55", "19:00", "19:05", "19:10",
      "19:15", "19:20", "19:25", "19:30", "19:35", "19:40", "19:45", "19:50",
      "19:55", "20:00", "20:05", "20:10", "20:15", "20:20", "20:25", "20:30",
      "20:35", "20:40", "20:45", "20:50", "20:55", "21:00", "21:05", "21:10",
      "21:15", "21:20", "21:25", "21:30", "21:35", "21:40", "21:45", "21:50",
      "21:55", "22:00", "22:05", "22:10", "22:15", "22:20", "22:25", "22:30",
      "22:35", "22:40", "22:45", "22:50", "22:55", "23:00", "23:05", "23:10",
      "23:15", "23:20", "23:25", "23:30", "23:35", "23:40", "23:45", "23:50",
      "23:55"];




    this.ngxUiLoaderService.stop("loader-01");

  }

  ngOnInit(): void {  
    this.flagFunc();
    this.regionFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => {
          if (search) {
            return this.filterRegions(search);
          }

          if (this.selectedRegions) {
            return this.selectedRegions.slice();
          }

          return [];
        }
        )
      )
      .subscribe(filtered => {
        this.filteredRegions.next(filtered);
      });
    this.userFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => {
          if (search) {
            return this.filterUsers(search);
          }

          if (this.userdropdown) {
            return this.userdropdown.slice();
          }

          return [];
        }
        )
      )
      .subscribe(filtered => {
        this.filteredUsers.next(filtered);
      });
    this.puserFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => {
          if (search) {
            return this.filterUsers(search);
          }

          if (this.userdropdown) {
            return this.userdropdown.slice();
          }

          return [];
        }
        )
      )
      .subscribe(filtered => {
        this.filteredUsers.next(filtered);
      });
  }

  addtask() {

    if (this.selected_period == undefined) { // NOSONAR
      this.errorMessage = "Please fill in the required fields!";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else if ((!this.selected_puser && !this.selected_region) || (!this.selected_puser && this.selected_region == '')) { // NOSONAR
      this.errorMessage = "At least a Primary user or a region must be selected.";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else {


      console.info("board", this.selected_board, "task", this.selectedTask, "period id", this.selected_period, "dday",
        this.selected_dday, "duetime", this.selected_duetime, "sequence", this.selected_sequence, "puser",
        this.selected_puser, "suser", this.selected_suser, "region", this.selected_region, "updaetd by", this.userID);



      if (this.selected_puser) {
        this.selected_pValue = this.selected_puser.value;
      }


      if (this.selected_suser) {
        this.selected_sValue = this.selected_suser.value;
      }

      if (this.selected_region) {
        this.selected_region.forEach(element => {

          this.selected_region_Temp_final.push(element.value);
        });

        this.selected_reg = this.selected_region_Temp_final.toString();
      }



      const userData = sessionStorage?.getItem('FGA');
      if (userData) {
        this.userID = JSON.parse(userData)?.user?.userPrincipalName;
      }




      // due time format logic


      this.addtask_sub()

    }

  }

  addtask_sub() {
    const dateObj = new Date();
    const month = dateObj.getUTCMonth() + 1; //months from 1-12
    const day = dateObj.getUTCDate();
    const year = dateObj.getUTCFullYear();

    let due_time;

    if (!this.selected_duetime) {
      due_time = '23:59';
    } else {
      due_time = this.selected_duetime;
    }

    const due = month + "-" + day + "-" + year + ' ' + due_time;

    // not undefined
    if (!this.selected_puser) {
      this.selected_puser = null;
    }
    if (!this.selected_suser) {
      this.selected_suser = null;
    }
    if (this.selected_region == '' || !this.selected_region) { // NOSONAR
      this.selected_region = null;
    }


    const dataArr = {
      "intuserID": this.userID,
      "boardID": this.boardID,
      "taskID": this.taskID,
      "periodID": this.selected_period,
      "dday": this.selected_dday,
      "due": due,
      "sequence": this.selected_sequence,
      "primaryUser": this.selected_pValue,
      "secondaryUser": this.selected_sValue,
      "regions": this.selected_reg,
      "boardTaskID": this.boardTaskID
    }



    this.ngxUiLoaderService.start("loader-01");

    this.boardService.saveperiodTask(dataArr).subscribe(_result => {


      this.successMessage = 'Board Task Saved Successfully!';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);

      this.ngxUiLoaderService.stop("loader-01");
      // }
    });


    // reset values
    this.selected_region_Temp_final = [];
  }
  flagFunc() {
    if (this.selected_region == undefined) { // NOSONAR
      this.s_region_flag = true;
    }
    else if (this.selected_region.length == 0) { // NOSONAR
      this.s_region_flag = true;
    }
    else if (this.selected_region.length > 0) {
      this.s_region_flag = false;
    }

  }
  filterRegions(search: string): { label: string; value: string }[] {
    // return filtered array
    return this.selectedRegions.filter(region =>
      region.label.toLowerCase().includes(search.toLowerCase())
    );

  }
  isAllSelected(): boolean {
    return this.selected_region?.length == this.selectedRegions.length; // NOSONAR
  }

  isIndeterminate(): boolean {
    return this.selected_region?.length > 0 && !this.isAllSelected();
  }
  toggleSelectAll(event: any): void {
    if (event.checked) {
      this.selected_region = [...this.selectedRegions];
    } else {
      this.selected_region = [];
    }
  }
  filterSUsers(search: string): void {
    const term = search.toLowerCase();
    this.filteredUserDropdown = this.userdropdown.filter(user =>
      user.label.toLowerCase().includes(term)
    );
  }
  filterUsers(search: string): any[] {
    if (!search) {
      return this.userdropdown.slice();
    }

    return this.userdropdown.filter(user =>
      user.label.toLowerCase().includes(search.toLowerCase())
    );
  }

  isAllUserSelected(): boolean {
    return this.selected_suser.length == this.userdropdown.length; // NOSONAR
  }

  isUserIndeterminate(): boolean {
    const selectedCount = this.selected_suser.length;
    return selectedCount > 0 && selectedCount < this.userdropdown.length;
  }

  toggleSelectAllUser(event: any): void {
    if (event.checked) {
      this.selected_suser = [...this.userdropdown];
    } else {
      this.selected_suser = [];
    }
  }
  isAllPUserSelected(): boolean {
    return this.selected_puser.length == this.userdropdown.length; // NOSONAR
  }

  isPUserIndeterminate(): boolean {
    const selectedCount = this.selected_puser.length;
    return selectedCount > 0 && selectedCount < this.userdropdown.length;
  }

  toggleSelectAllPUser(event: any): void {
    if (event.checked) {
      this.selected_puser = [...this.userdropdown];
    } else {
      this.selected_puser = [];
    }
  }

  compareRegion = (a: any, b: any): boolean => {
    return a && b && a.value == b.value; // NOSONAR
  };


}

